<template>

<div>
     <HeaderBreadcrumbs
  :items="[
    { label: 'Books', to: '/ebooks' },
    { label: `Bulk Create New Data`, to: `/items/bulk-csv/upload/${this.slug}` },
    { label: 'History' }
  ]"
  title="History"
/>
  <div class="border rounded-xl overflow-hidden mb-5">
<Table :headers="headers" :data="items" :withNumberCol="false"
      :row-key="['file_name','created_at', 'total_items','status', 'created_by']"
     :current-page="currentPage" :isLoading="isLoading"
      :per-page="15">
        <template #header-file-name="{ column }">
            <div class="flex justify-between items-center gap-1 px-3">
              {{ column.label }}
              <button @click="sortByFileNmae(column.key)" class="text-xs text-gray-500">
                <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
              </button>
            </div>
          </template>
           <template #header-date="{ column }">
            <div class="flex justify-between items-center gap-1 px-3">
              {{ column.label }}
              <button @click="sortBy(column.key)" class="text-xs text-gray-500">
                <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
              </button>
            </div>
          </template>
           <template #created_at="{ value }">
            <p class="px-3 mb-0">{{ formatDate(value) }}</p>
            </template>
            <template #status="{ value }">
                   <div v-if ="value ===1">
                    <span class='bg-green-100 p-1 rounded-lg text-green-600 text-xs'>Success</span>
                   </div>
                   <div v-else>
                     <span class='bg-red-100 p-1 rounded-lg text-red-500 text-xs'>Error Server</span>
                   
                   </div>
            </template>
            <template #total_items="{ value }">
              <p class="text-right mb-0">{{ value }}</p>
            </template>
             <template #file_name="{ value }">
              <p class="text-left px-3 lowercase mb-0">{{ value }}</p>
            </template>
             <template #created_by="{ value }">
              <p class="lowercase mb-0">{{ value }}</p>
            </template>
            
    </Table>
     <div v-if="!isLoading && items.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-0">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ items.length }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="15" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
  </div>

</div>
</template>

<script>
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs';
import { mapActions, mapState } from 'vuex';
import moment from 'moment'
import Table from '@/components/form/table.vue';

export default {
    components: {
    HeaderBreadcrumbs,
    Table
  },
   data() {
    return {
      slug: '',
      currentPage:1,
      sortOrder: 'created_at_desc',
      sortOrderFileName: 'file_name_desc',
       headers: [
       {},
         { label: 'File name', key: 'file_name', sortable:true, slotHeader: 'header-file-name' ,style: 'padding-left: 16px; padding-right: 16px;'},
         { label: 'Import Date', key:'created_at', sortable: true, slotHeader: 'header-date',style: 'padding-left: 16px; padding-right: 16px;' },
         { label: 'Total ROWS', key: '' ,style: 'width: 100px; padding-left: 16px; padding-right: 16px;'},
        { label: 'Status', key: '' ,style: 'width: 250px; padding-left: 16px; padding-right: 16px;'},
        { label: 'Processed By', key: '' , style: 'width: 100px; padding-left: 16px; padding-right: 16px;'}
      ],
    };
  },
   mounted() {
    this.slug = this.$route.params.slug
    this.fetchBulkItem()
    },


  computed: {
  ...mapState({
    items: state => state.bulkUpload.items,
    totalRows: (state) => state.bulkUpload.totalRows,
     isLoading: (state) => state.bulkUpload.isLoading,
  })
},
  methods:{
     ...mapActions('bulkUpload', ['getBulkItemCsv']),
     fetchBulkItem() {
        this.getBulkItemCsv({
          page: this.currentPage,
          limit: 15,
          sort: this.sortOrder
        })
},
onClickPage(page)
{
this.currentPage = page;
this.fetchBulkItem()
},
 sortBy() {
  this.sortOrder = this.sortOrder === 'created_at_asc' ? 'created_at_desc' : 'created_at_asc'

  this.getBulkItemCsv({
    page: this.currentPage,
    limit: 15,
    sort: this.sortOrder,
   // order_by: sortByPeriode
  })
},
sortByFileNmae() {
  this.sortOrderFileName = this.sortOrderFileName === 'file_name_asc' ? 'file_name_desc' : 'file_name_asc'

  this.getBulkItemCsv({
    page: this.currentPage,
    limit: 15,
    sort: this.sortOrderFileName,
   // order_by: sortByPeriode
  })
},
formatDate(date) {
  if (!date) return '-'
  return moment(date).format('DD MMMM YYYY, HH:mm')
}
  },
 
}
</script>